import * as React from 'react'
import { View, TouchableOpacity, Text } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'
import theme from '@theme/Theme'

export interface RadioOption {
  label?: string
  description?: string
  renderItem?: () => JSX.Element
  value: any
}

interface Props {
  data: RadioOption[]
  disabled?: boolean
  horizontalPadding?: boolean
  iconOnTheRight?: boolean
  onItemSelected: (opt: RadioOption) => void
  value?: RadioOption
  withoutSeparators?: boolean
}

const Radio = ({
  data,
  disabled = false,
  horizontalPadding,
  iconOnTheRight = false,
  onItemSelected,
  value,
  withoutSeparators = false,
}: Props) => {
  const renderRadioItem = (item: RadioOption, index: number, list: RadioOption[]) => (
    <Container
      key={JSON.stringify(item.value)}
      disabled={disabled}
      iconOnTheRight={iconOnTheRight}
      horizontalPadding={horizontalPadding}
      activeOpacity={0.9}
      onPress={() => onItemSelected(item)}
      withoutSeparator={withoutSeparators || index === list.length - 1}>
      <Icon
        name={value && value.value === item.value ? 'radio_filled' : 'radio_empty'}
        size={24}
        color={disabled ? theme.colors.disable : theme.colors.primary}
      />
      {!!item.renderItem
        ? item.renderItem()
        : !!item.label && (
            <Content>
              <Label iconOnTheRight={iconOnTheRight} disabled={disabled}>
                {item.label}
              </Label>
              {!!item.description && <Description>{item.description}</Description>}
            </Content>
          )}
    </Container>
  )

  return <View>{data.map(renderRadioItem)}</View>
}

export default Radio

const Container = styled(TouchableOpacity)<{
  iconOnTheRight: boolean
  withoutSeparator: boolean
  horizontalPadding?: boolean
}>`
  flex-direction: ${(props) => (props.iconOnTheRight ? 'row-reverse' : 'row')};
  align-items: center;
  padding: ${(props) => (props.horizontalPadding ? '10px 16px' : '10px 0px')};
  ${(props) => !props.withoutSeparator && `border-bottom-width: 1px; border-color: ${props.theme.colors.disable};`}
`

const Label = styled(Text)<{ iconOnTheRight: boolean; disabled: boolean }>`
  ${(props) => props.theme.fonts.Option};
  color: ${(props) => (props.disabled ? props.theme.colors.disable : props.theme.colors.primaryText)};
  padding: ${(props) => (props.iconOnTheRight ? `0px 10px 0 0px` : `0px 0 0 10px`)};
`

const Content = styled(View)`
  flex: 1;
`

const Description = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => props.theme.colors.secondaryText};
  margin: 4px 0 0 10px;
`
